import { defineMessages } from "react-intl";

export default defineMessages({
  btnText: {
    id: "components.EntityPlaceholder.btnText",
    defaultMessage: "Add Cameras to New {type}"
  }
});
